import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import {
  PlacesData,
  ReverseGeocodingPayload,
  ReverseGeocodingResponse,
  SearchPlacePayload
} from "@/types/place";

import { getPlaceApi, getReverseGeocoding } from "./placeApi";

export const PLACE_KEYS = {
  place: ["search-place"] as const
} as const;

export const useSearchPlaceQuery = (
  params?: SearchPlacePayload,
  options?: Omit<
    UseQueryOptions<PlacesData, Error, PlacesData>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: [PLACE_KEYS.place, params],
    queryFn: () => getPlaceApi(params),
    ...options
  });
};

export const useReverseGeocodingQuery = (
  params?: ReverseGeocodingPayload,
  options?: Omit<
    UseQueryOptions<
      ReverseGeocodingResponse[],
      Error,
      ReverseGeocodingResponse[]
    >,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["reverse-geocoding", params],
    queryFn: () => getReverseGeocoding(params),
    ...options
  });
};
